import { render, staticRenderFns } from "./MembershipHeader.vue?vue&type=template&id=3912bbe4"
import script from "./MembershipHeader.vue?vue&type=script&lang=js"
export * from "./MembershipHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports